import { blogPosts } from "../../../mocks/blog";

interface BlogHeroProps {
  search: string;
  onSearch: (val: string) => void;
}

export default function BlogHero({ search, onSearch }: BlogHeroProps) {
  return (
    <section className="pt-16 bg-[#222831]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#C9A227] mb-4">
          <i className="ri-book-open-line text-sm"></i>
          The Sourcing Intelligence Hub
        </span>
        <h1 className="text-4xl lg:text-6xl font-extrabold text-white leading-tight max-w-3xl">
          Insights for Smarter{" "}
          <span className="text-[#C9A227]">Procurement</span>
        </h1>
        <p className="mt-5 text-base text-white/60 max-w-xl leading-relaxed">
          Expert articles on product sourcing, wholesale buying, inventory management,
          logistics, and supply chain strategy — written by the LTF Sourcing team.
        </p>

        {/* Search bar */}
        <div className="mt-8 w-full max-w-xl relative">
          <div className="relative flex items-center">
            <i className="ri-search-line absolute left-4 text-white/30 text-lg pointer-events-none"></i>
            <input
              type="text"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="Search articles, topics, or keywords…"
              className="w-full pl-11 pr-12 py-4 rounded-xl bg-white/10 border border-white/20 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#C9A227] transition-colors"
            />
            {search && (
              <button
                onClick={() => onSearch("")}
                className="absolute right-4 text-white/40 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            )}
          </div>
          {search && (
            <p className="mt-2 text-xs text-white/40 text-left">
              Searching across {blogPosts.length} articles…
            </p>
          )}
        </div>

        {/* Stats strip */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-8">
          {[
            { value: `${blogPosts.length}+`, label: "Articles Published" },
            { value: "5", label: "Topic Categories" },
            { value: "6", label: "Expert Contributors" },
            { value: "Weekly", label: "New Content" },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col items-center gap-1">
              <span className="text-2xl font-extrabold text-[#C9A227]">{stat.value}</span>
              <span className="text-xs text-white/50 uppercase tracking-widest">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Decorative bottom edge */}
      <div className="h-8 bg-white rounded-t-3xl"></div>
    </section>
  );
}
